import { render } from "./SpaymentReceiptsView.vue?vue&type=template&id=7525b6ee&scoped=true"
import script from "./SpaymentReceiptsView.vue?vue&type=script&lang=js"
export * from "./SpaymentReceiptsView.vue?vue&type=script&lang=js"

import "./SpaymentReceiptsView.vue?vue&type=style&index=0&id=7525b6ee&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7525b6ee"]])

export default __exports__